export default __webpack_public_path__ + "static/media/iphone-8-sketboard.5830e94c.png";